import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/categories/scarf.jpg")